import type { VehicleValuationVehicleDataRepairStatusResponse } from "@/common/api/vehicle-valuation/use-vehicle-valuation-vehicle-data-repair-status.query";
import { CommandButton } from "@/components/command-palette/command-button";
import { ButtonColorVariant, ButtonVariant } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { WandSparklesIcon } from "lucide-react";
import type { ReactElement } from "react";

interface VehicleValuationVehicleDataRepairButtonProps {
  status: VehicleValuationVehicleDataRepairStatusResponse | undefined;
  isPending: boolean;
  label: string;
  unavailableTitle: string;
  onClick: () => void;
}

export function VehicleValuationVehicleDataRepairButton({
  status,
  isPending,
  label,
  unavailableTitle,
  onClick,
}: VehicleValuationVehicleDataRepairButtonProps): ReactElement | null {
  if (!status?.needed) {
    return null;
  }

  const isUnavailable = !status.possible;
  const button = (
    <CommandButton
      commandId="vehicle-valuation-repair-vehicle-data"
      label={label}
      icon={<WandSparklesIcon />}
      variant={ButtonVariant.Outlined}
      colorVariant={ButtonColorVariant.Secondary}
      disabled={isUnavailable || isPending}
      onClick={onClick}
    >
      <WandSparklesIcon className="mr-2 h-4 w-4" />
      {label}
    </CommandButton>
  );

  if (!isUnavailable) {
    return button;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex cursor-not-allowed" tabIndex={0} aria-disabled="true">
            {button}
          </span>
        </TooltipTrigger>
        <TooltipContent>{unavailableTitle}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
